import { useMutation, useQueryClient } from "@tanstack/react-query"
import { AxiosError } from "axios";
import { Member } from "src/redux/types/_customer.type";
import { memberKeys } from "./useFetchMembers";
import { editBloodGroup } from "src/redux/api/_customer.api";
import { toast } from "react-toastify";

interface Variables{
  memberId: number;
  subscriptionId: number;
  values: {
    blood_group: string;
  }
}

export const useEditBloodGroup = () => {
  
  const queryClient = useQueryClient();
  
  return useMutation<Member, AxiosError, Variables>({
    mutationFn: ({ memberId, values }) => editBloodGroup(memberId, values),
    onSuccess: (_, { subscriptionId }) => {
      queryClient.invalidateQueries({
        queryKey: memberKeys.list(subscriptionId),
      });
      toast.success("Updated successfully");
    },
    onError: (error) => {
      toast.error("Failed to update");
      console.error(error);
    },
  });
}